module.exports = __webpack_public_path__ + "img/140.6.8787624d.png";